// extracted by mini-css-extract-plugin
module.exports = {"container":"Score_container__3NXLU","scoreContainer":"Score_scoreContainer__3Jz2U","left":"Score_left__1ktUz","right":"Score_right__1SBX9","updatedAt":"Score_updatedAt__16uX6"};